
const state = {
    specialDayOff: [],
    specialDayOn: [],
    openHour: {},
    selectedDateOpenHours: []
};

const getters = {
};

const actions = {

}

const mutations = {
    SET_SPECIAL_DAYOFF(state, payload) {
        state.specialDayOff = payload
    },
    SET_SPECIAL_DAYON(state, payload) {
        state.specialDayOn = payload
    },
    SET_OPEN_HOUR(state, payload) {
        state.openHour = payload
    },
    SET_SELECTED_DATE_OPEN_HOUR(state, payload) {
        state.selectedDateOpenHours = payload
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/masterData.js